import { jsx as _jsx } from "react/jsx-runtime";
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function Spinner(_a) {
    var sm = _a.sm;
    return (_jsx("div", { className: "spinner-border ".concat(sm ? 'sm' : '') }, void 0));
}
export default Spinner;
